
export class CookieUtils {

	public static clearCookie(): void {
		document.cookie = `uvexplorer.session=;path=/;expires=expires=Thu, 01 Jan 1970 00:00:00 UTC`;
	}

	public static getCookie(): string {
		let cookie: string = "";

		if (!!document.cookie) {
			cookie = document.cookie.split('; ').find(row => row.startsWith('uvexplorer.session='))
			if (!!cookie) {
				cookie = cookie.split('=')[1];
			}
		}

		if (!cookie) {
			cookie = "";
		}

		return cookie;
	}

	public static setCookie(value: string): void {
		let expires = new Date();
		expires.setUTCFullYear(2100, 0, 1);
		document.cookie = `uvexplorer.session=${value};path=/;expires=${expires.toUTCString()}`;
	}

}